import { FETCH_SALES_DETAIL, FETCH_SALES_ORDER_ITEM_LIST, FETCH_SALES_ORDER_PROCESSING, FETCH_SALES_STATUS_COUNT ,FETCH_ESOPFORM_TABLE_DATA,FETCH_PASSLINK_VALIDATION_TOKEN,
     FETCH_ASSOCIATED_JOB, FETCH_ASSOCIATED_TRIP, FETCH_AVAILABLE_SLOTS, FETCH_SALES_ORDER_CARD_COUNT, VALIDATE_SALES_CONSUMPTION, FETCH_SALES_ORDER_DISPATCH_PLANS } from "../types"


const INIT_STATE ={
    allSalesOrderTableData :[],
    allSalesOrderTabletotalRows:0,
    allSaleOrderItems: [],
    orderItemRows: 0,
    SO_Number: "",
    eSOPFormTableData:[],
    passLinkValidationToken:"",
    associatedJobData: [],
    associatedJobRows: 0,
    associatedTripData: [],
    associatedTripRows: 0,
    availableSlots: [],
    salesOrderCardCount: null,
    validatedWarehousesList: [],
    saleDispatchPlans: [],
    saleDispatchPlansCount: 0
}

export default (state=INIT_STATE, action) =>{
    switch(action.type) {
        case FETCH_SALES_ORDER_PROCESSING :return {...state, allSalesOrderTableData: action?.payload?.data || [], allSalesOrderTabletotalRows: action?.payload?.count || 0}
        case FETCH_SALES_ORDER_DISPATCH_PLANS :return {...state, saleDispatchPlans: action?.payload?.data || [], saleDispatchPlansCount: action?.payload?.count || 0}
        case FETCH_SALES_DETAIL: return {...state, SalesDetail: action.payload.data, SalesDetailItemsCount: action.payload.count}
        case FETCH_SALES_STATUS_COUNT: return {...state, statusCount: action.payload}
        case FETCH_SALES_ORDER_ITEM_LIST :return {
            ...state, 
            allSaleOrderItems: action.payload.rows, 
            orderItemRows: action.payload.count,
            applyExtraValue: action.payload.applyExtraValue || {}
        }
        case FETCH_ESOPFORM_TABLE_DATA : return {...state, eSOPFormTableData:action.payload}
        case FETCH_PASSLINK_VALIDATION_TOKEN :  return {...state, passLinkValidationToken:action.payload}
        case FETCH_SALES_ORDER_CARD_COUNT :  return {...state, salesOrderCardCount:action.payload}
        case FETCH_ASSOCIATED_JOB: return {...state, associatedJobData: action.payload.data, associatedJobRows: action.payload.count}
        case FETCH_ASSOCIATED_TRIP: return {...state, associatedTripData: action.payload.data, associatedTripRows: action.payload.count}
        case FETCH_AVAILABLE_SLOTS: return {...state, availableSlots: action.payload.data}
        case VALIDATE_SALES_CONSUMPTION: return {...state, validatedWarehousesList: action.payload.data}
        default: return state
    }
}